// extracted by mini-css-extract-plugin
export default {"bodyLabel":"iOWMHK","bodyCodeBlock":"_IcOQk"};